(function () {
  var duplicateClass = 'bollide-okendo-duplicate';
  var updateQueued = false;

  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function hideDuplicateReviews() {
    document.querySelectorAll('.oke-w-reviews-list').forEach(function (reviewList) {
      var seenReviews = new Set();

      reviewList.querySelectorAll('.oke-w-reviews-list-item').forEach(function (reviewItem) {
        var reviewer = reviewItem.querySelector('.oke-w-reviewer-name');
        var title = reviewItem.querySelector('.oke-reviewContent-title');
        var body = reviewItem.querySelector('.oke-reviewContent-body, .oke-bodyText');
        var normalizedBody = normalize(body && body.textContent);
        var signature = [
          normalize(reviewer && reviewer.textContent),
          normalize(title && title.textContent),
          normalizedBody
        ].join('|');

        if (normalizedBody.length >= 40 && seenReviews.has(signature)) {
          reviewItem.classList.add(duplicateClass);
          reviewItem.setAttribute('aria-hidden', 'true');
        } else {
          reviewItem.classList.remove(duplicateClass);
          reviewItem.removeAttribute('aria-hidden');
          if (normalizedBody.length >= 40) seenReviews.add(signature);
        }
      });
    });
  }

  function queueUpdate() {
    if (updateQueued) return;
    updateQueued = true;

    window.requestAnimationFrame(function () {
      updateQueued = false;
      hideDuplicateReviews();
    });
  }

  function mutationContainsReviews(mutation) {
    var target = mutation.target && mutation.target.nodeType === 1
      ? mutation.target
      : mutation.target && mutation.target.parentElement;

    if (target && target.closest && target.closest('.oke-w-reviews-list')) return true;

    return Array.prototype.some.call(mutation.addedNodes, function (node) {
      return node.nodeType === 1 && (
        node.matches('.oke-w-reviews-list, .oke-w-reviews-list-item')
        || node.querySelector('.oke-w-reviews-list, .oke-w-reviews-list-item')
      );
    });
  }

  function init() {
    var style = document.createElement('style');
    style.textContent = '.oke-w-reviews-list-item.' + duplicateClass + '{display:none!important;}';
    document.head.appendChild(style);

    hideDuplicateReviews();

    new MutationObserver(function (mutations) {
      if (mutations.some(mutationContainsReviews)) queueUpdate();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
